module.exports = __webpack_public_path__ + "747b8feae9071046c781f8d20c7d0885.svg";